export default __webpack_public_path__ + "media/images/react_icons/casatb/whatsapp_gray-67e896e42b258aea2a69de5770555125.svg";